import graphqlClient from "../utils/graphql_client_util";

const QUERIES = {
  GENERAL_BOARD_LIST: `
    query GeneralBoardList($input: GeneralBoardSearchInput!) {
      generalBoardList(input: $input) {
        totalPages
        totalElements
        success
        size
        page
        error {
          code
          errorType
          message
        }
        data {
          answer
          answerDate
          answerSeq
          boardSeq
          categoryName
          categorySeq
          content
          detailType
          detailTypeName
          isDeleted
          modDate
          modName
          regDate
          regName
          title
          type
          typeName
          userId
          userSeq
          description
        }
      }
    }
  `,
};

export const getGeneralBoardList = async (
  type = "ALL",
  page = 0,
  size = 10
) => {
  try {
    const params = {
      type: type,
      page: page,
      size: size,
    };

    // if (type === "EVENT") {
    //   params["type"] = "ALL";
    //   params["detailType"] = "NOTICE_EVENT";
    // }

    const data = await graphqlClient.query(
      QUERIES.GENERAL_BOARD_LIST,
      {
        input: params,
      },
      { useAuth: false }
    );

    if (data.generalBoardList.success) {
      return {
        success: true,
        data: data.generalBoardList.data,
        totalPages: data.generalBoardList.totalPages,
        totalElements: data.generalBoardList.totalElements,
        page: data.generalBoardList.page,
        size: data.generalBoardList.size,
      };
    } else {
      return {
        success: false,
        error: data.generalBoardList.error,
      };
    }
  } catch (err) {
    console.error("Error fetching general board list:", err);

    return {
      success: false,
      error: {
        message: "게시판 목록을 불러오는데 실패했습니다.",
        errorType: "NETWORK_ERROR",
      },
    };
  }
};

export const getBoardListByType = async (type, page = 0, size = 10) => {
  return await getGeneralBoardList(type, page, size);
};

export const getNoticeList = async (page = 0, size = 10) => {
  return await getGeneralBoardList("NOTICE", page, size);
};

export const getEventList = async (page = 0, size = 10) => {
  return await getGeneralBoardList("EVENT", page, size);
};

export const getFAQList = async (page = 0, size = 10) => {
  return await getGeneralBoardList("FAQ", page, size);
};
